import React from "react";
import Navbar from "../components/navbar";
import Footer from "../components/footer";
import RnDSection from "./RnDSection";
import InfinitePossibilities from "./InfinitePossibilities";
import ResearchMain from "./ResearchMain";
import RDFacility from "./RDFacility";

const RnDPage: React.FC = () => {
  return (
    <div className="w-full bg-white min-h-screen">
      <Navbar />
      <RnDSection />
      <RDFacility />
      <InfinitePossibilities />
      <ResearchMain />
      <Footer />
    </div>
  );
};

export default RnDPage;